import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Auth/Dashboard.vue'
import Product from './views/Auth/Product.vue'
import Catagory from './views/Auth/Catagory.vue'
import Promotion from './views/Auth/Promotion.vue'
import PointManagement from './views/Auth/PointManagement.vue'
import BannerManagement from './views/Auth/BannerManagement.vue'
import RedeemedTransactions from './views/Auth/RedeemedTransactions.vue'
import AgentManagement from './views/Auth/AgentManagement.vue'
import UserManagement from './views/Auth/UserManagement.vue'
import Profile from './views/Auth/Profile.vue'
import SaleManagement from './views/Auth/SaleManagement.vue'
import Login from './views/Login'
import ForgetPassword from './views/ForgetPassword'
import Register from './views/Register'
import RedeemForm from './views/Auth/RedeemForm'
import ConfirmPassword from './views/ConfirmPassword'
import Notify from './views/Auth/Notify'
import ReportEmail from './views/Auth/ReportEmail'
import AgentLineManagement from './views/Auth/AgentLineManagement'
import EmployeeLineManagement from './views/Auth/EmployeeLineManagement'
import SmartAlert from './views/Auth/SmartAlert'
import AgentBranch from './views/Auth/AgentBranch'
// import TargetStep from './views/Auth/TargetStep'
// import Privileges from './views/Auth/Privileges'
import CTTDashboard from './views/AuthTT/CTTDashboard'
import CTTCampaignDashboard from './views/AuthTT/CTTCampaignDashboard'
import CTTRetailShop from './views/AuthTT/CTTRetailShop'
import CTTNetworkShop from './views/AuthTT/CTTNetworkShop'
import CTTAreaPromoter from './views/AuthTT/CTTAreaPromoter'
import CTTAreaPromoterCRM from './views/AuthTT/CTTAreaPromoterCRM'
import CTTApproveAreaPromoterCRM from './views/AuthTT/CTTApproveAreaPromoterCRM'
import CTTReward from './views/AuthTT/CTTReward'
import CTTSpecialReward from './views/AuthTT/CTTSpecialReward'
import CTTVansales from './views/AuthTT/CTTVansales'

import PDFViewer from './views/PDFViewer'

// import Obs from './views/Obs'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/forgetPassword',
      name: 'forgetPassword',
      component: ForgetPassword,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    // ------ Chang Family ------
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
    },
    {
      path: '/product',
      name: 'product',
      component: Product,
    },
    {
      path: '/catagory',
      name: 'catagory',
      component: Catagory,
    },
    {
      path: '/promotion',
      name: 'promotion',
      component: Promotion,
    },
    {
      path: '/pointManagement',
      name: 'pointManagement',
      component: PointManagement,
    },
    {
      path: '/bannerManagement',
      name: 'bannerManagement',
      component: BannerManagement,
    },
    {
      path: '/redeemedTransactions',
      name: 'redeemedTransactions',
      component: RedeemedTransactions,
    },
    {
      path: '/userManagement',
      name: 'userManagement',
      component: UserManagement,
    },
    {
      path: '/agentManagement',
      name: 'agentManagement',
      component: AgentManagement,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/saleManagement',
      name: 'saleManagement',
      component: SaleManagement,
    },
    {
      path: '/redeemForm',
      name: 'redeemForm',
      component: RedeemForm,
    },
    {
      path: '/confirmPassword',
      name: 'confirmPassword',
      component: ConfirmPassword,
    },
    {
      path: '/notify',
      name: 'notify',
      component: Notify,
    },
    {
      path: '/reportEmail',
      name: 'reportEmail',
      component: ReportEmail,
    },
    {
      path: '/agentLineManagement',
      name: 'agentLineManagement',
      component: AgentLineManagement,
    },
    {
      path: '/employeeLineManagement',
      name: 'employeeLineManagement',
      component: EmployeeLineManagement,
    },
    {
      path: '/smartAlert',
      name: 'smartAlert',
      component: SmartAlert,
    },
    {
      path: '/agentBranch',
      name: 'agentBranch',
      component: AgentBranch,
    },
    // {
    //   path: '/targetStep',
    //   name: 'targetStep',
    //   component: TargetStep
    // },
    // {
    //   path: '/privileges',
    //   name: 'privileges',
    //   component: Privileges
    // },
    // ------ Chang TT ------
    {
      path: '/cttDashboard',
      name: 'cttDashboard',
      component: CTTDashboard,
    },
    {
      path: '/cttCampaignDashboard',
      name: 'cttCampaignDashboard',
      component: CTTCampaignDashboard,
    },
    {
      path: '/cttRetailShop',
      name: 'cttRetailShop',
      component: CTTRetailShop,
    },
    {
      path: '/cttNetworkShop',
      name: 'cttNetworkShop',
      component: CTTNetworkShop,
    },
    {
      path: '/cttAreaPromoter',
      name: 'cttAreaPromoter',
      component: CTTAreaPromoter,
    },
    {
      path: '/cttVansales',
      name: 'cttVansales',
      component: CTTVansales,
    },
    {
      path: '/cttAreaPromoterCRM',
      name: 'cttAreaPromoterCRM',
      component: CTTAreaPromoterCRM,
    },
    {
      path: '/cttReward',
      name: 'cttReward',
      component: CTTReward,
    },
    {
      path: '/cttSpecialReward',
      name: 'cttSpecialReward',
      component: CTTSpecialReward,
    },
    {
      path: '/cttApproveAreaPromoterCRM',
      name: 'cttApproveAreaPromoterCRM',
      component: CTTApproveAreaPromoterCRM,
    },
    {
      path: '/pdfViewer',
      name: 'pdfViewer',
      component: PDFViewer,
    },
    // {
    //   path: '/obs',
    //   name: 'obs',
    //   component: Obs,
    // },
  ],
})

router.beforeEach((to, from, next) => {
  const user = Vue.prototype.$user
  const ciPages = ['/notify', '/reportEmail', '/smartAlert', '/agentBranch']
  const regionPages = [
    '/cttDashboard',
    '/cttAreaPromoter',
    '/cttVansales',
    '/cttAreaPromoterCRM',
    '/cttReward',
    '/cttSpecialReward',
    '/cttApproveAreaPromoterCRM',
  ]

  // CI
  if (ciPages.includes(to.path) && user.role != 'ci') {
    return next('/product')
  }

  // Region Admin
  if (
    regionPages.includes(to.path) &&
    !(user.role === 'ci' || user.role === 'admin')
  ) {
    return next('/product')
  }

  next()
})

export default router
